import React from 'react';
import { Alert, Button, Drawer, Input, Space, Upload, Typography, Row, Col } from 'antd';
import type { UploadFile } from 'antd/es/upload/interface';

const { Text } = Typography;
type OnValueChange = (nextValue: string) => void;

type IsgKatipContractDrawerProps = {
  open: boolean;
  onClose: () => void;
  hasPlan: boolean;
  contractUrl: string | null;
  contractId: string;
  onContractIdChange: OnValueChange;
  onContractIdSave: () => void;
  canSaveContractId: boolean;
  contractFileList: UploadFile<any>[];
  onContractFileListChange: (files: UploadFile<any>[]) => void;
  saving: boolean;
  readOnly?: boolean;
};

const IsgKatipContractDrawer: React.FC<IsgKatipContractDrawerProps> = ({
  open,
  onClose,
  hasPlan,
  contractUrl,
  contractId,
  onContractIdChange,
  onContractIdSave,
  canSaveContractId,
  contractFileList,
  onContractFileListChange,
  saving,
  readOnly = false,
}) => {
  return (
    <Drawer
      title='İSG-KATİP İşlemleri'
      open={open}
      onClose={onClose}
      destroyOnClose
      width={500}
    >
      {!hasPlan ? (
        <Text>Plan üzerinde size atanan bir görev bulunamadı.</Text>
      ) : (
        <div style={{ width: '100%' }}>
          <div>
            <Text strong>Yeni Sözleşme Dosyası</Text>
            <Row align='middle' gutter={8} style={{ marginTop: 8 }} justify={"start"}>
              <Col>
                <Upload
                  disabled={readOnly}
                  beforeUpload={() => false}
                  maxCount={1}
                  fileList={contractFileList}
                  accept='.pdf,image/*'
                  onChange={(info) => {
                    if (readOnly) {
                      return;
                    }
                    onContractFileListChange(info.fileList.slice(-1));
                  }}
                  onRemove={() => {
                    if (readOnly) {
                      return false;
                    }
                    onContractFileListChange([]);
                    return true;
                  }}
                >
                  <Button disabled={readOnly}>Dosya Seç</Button>
                </Upload>
                {contractFileList.length > 0 ? (
                  <Text type='secondary'>{contractFileList[0]?.name ?? 'Seçilen dosya'}</Text>
                ) : null}
              </Col>
            </Row>
            <Row>
              <div style={{ marginTop: 8 }}>
                {contractUrl ? (
                  <Space size={8}>
                    <Button type='link' href={contractUrl} target='_blank' rel='noreferrer'>
                      Sözleşmeyi görüntüle
                    </Button>
                  </Space>
                ) : (
                  <Alert
                    type='info'
                    showIcon
                    message='Henüz sözleşme yüklenmemiş.'
                    style={{ maxWidth: 400 }}
                  />
                )}
              </div>
            </Row>
          </div>
          <div style={{ marginTop: 16 }}>
            <Text strong>Sözleşme Numarası</Text>
            <br />
            <Input
              style={{ minWidth: 220, maxWidth: 260, marginTop: 8 }}
              value={contractId}
              placeholder='Sözleşme No'
              onChange={(event) => onContractIdChange(event.target.value)}
              disabled={readOnly}
            />
            <br />
            <Button
              style={{ marginTop: 8 }}
              type='primary'
              onClick={onContractIdSave}
              loading={saving}
              disabled={readOnly}
              aria-disabled={!canSaveContractId}
            >
              Kaydet
            </Button>
          </div>
        </div>
      )}
    </Drawer>
  );
};

export default IsgKatipContractDrawer;
